import React, { useCallback, useState, useEffect } from 'react';

import {
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage
} from '@chakra-ui/react';

const EmailComponent = ({
  dataId = null,
  fieldId,
  submitAttempted,
  defaultPlaceholder,
  fieldLabel,
  fieldValue,
  required,
  errorMessage,
  onChange = (v) => {},
  onReady = () => {}
}) => {
  const [isError, setIsError] = useState(required);

  const handleOnChange = useCallback(
    (value) => {
      const isInvalid = required === true && value.length === 0;

      setIsError(isInvalid);

      onChange({
        fieldId,
        dataId,
        value,
        label: fieldLabel,
        isValid: isInvalid === false
      });
    },
    [onChange, fieldId, dataId, fieldLabel, required]
  );

  useEffect(() => {
    onReady({
      fieldId,
      required
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl
      mb="3"
      isInvalid={submitAttempted && isError}
      isRequired={required}>
      <FormLabel
        id={`field-label-email-${fieldId}-${fieldLabel}`}
        htmlFor={fieldId}
        mb="1.5">
        {fieldLabel}
      </FormLabel>
      <Input
        type="email"
        dataid={dataId}
        id={fieldId}
        name={fieldLabel}
        placeholder={fieldValue || defaultPlaceholder}
        onChange={(event) => handleOnChange(event.target.value)}
        onBlur={(event) => handleOnChange(event.target.value)}
      />
      {submitAttempted && isError && (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default EmailComponent;
